import { useContext } from "react";
import { useParams } from "react-router-dom";
import { Button } from "rsuite";
import { GameContext } from "../../../app/context/GameContext";
import { useGetActivityByIdQuery } from "../../../entities/Activity/activityApi";
import type { MemoryCardsGameDetails } from "../../../entities/Activity/types/MemoryCardsGameDetails";
import { MemoryCardGame } from "../../../features/activities/MemoryCardsGame/MemoryCardsGame";
import style from "./style.module.scss";

export const MemoryCardGamePage = () => {
	const { setGameModalOpen } = useContext(GameContext);
	const { id = "" } = useParams();
	const { data: activity } = useGetActivityByIdQuery(id, { skip: !id });

	return (
		<div className={style.container}>
			<Button
				className={style.returnBtn}
				color="cyan"
				appearance="default"
				onClick={() => {
					setGameModalOpen(false);
					window.history.back();
				}}
			>
				Return
			</Button>
			<MemoryCardGame
				data={(activity?.details as MemoryCardsGameDetails)?.data || []}
			/>
		</div>
	);
};
